import React from 'react';
import PropTypes from 'prop-types';
import { Select, Card } from '@ipc/ipc-components';
import { DayPickerInput, FormLabel } from '../../../elements';

const ImmediateTypeComponent = ({
  values, validations, disabled, options, onDateChange, onSelectChange,
}) => (
  <Card>
    <div className="FormRow">
      <FormLabel title="Date Type" required hasError={!validations.dateType}>
        <Select options={options.dateType} value={values.dateType} className="Input SingleSelect" onChange={onSelectChange} name="dateType" isDisabled={disabled} />
      </FormLabel>
    </div>
    <div className="FormRow">
      <div className="FormRowInlineFlex">
        <FormLabel title="Reporting Start Date" required forDayPicker hasError={!validations.startDate}>
          <DayPickerInput value={values.startDate} onChange={onDateChange('startDate')} name="startDate" disabled={disabled} />
        </FormLabel>
        <FormLabel title="Reporting End Date" required forDayPicker hasError={!validations.endDate}>
          <DayPickerInput value={values.endDate} onChange={onDateChange('endDate')} name="endDate" disabled={disabled} />
        </FormLabel>
      </div>
    </div>
  </Card>
);

ImmediateTypeComponent.propTypes = {
  values: PropTypes.shape(),
  validations: PropTypes.shape(),
  options: PropTypes.shape(),
  disabled: PropTypes.bool,
  onDateChange: PropTypes.func,
  onSelectChange: PropTypes.func,
};

export default ImmediateTypeComponent;
